import { jsx as _jsx } from "react/jsx-runtime";
import { useRoutes as useBaseRoutes } from 'react-router-dom';
import ComponentsWrapper from '@src/components/ComponentsWrapper';
import CloseDevice from '@src/pages/CloseDevice';
import CurrierPage from '@src/pages/CurrierPage';
import Done from '@src/pages/Done';
import OwnerPage from '@src/pages/OwnerPage';
export function useRoutes() {
    return useBaseRoutes([
        {
            path: '/*',
            element: _jsx(ComponentsWrapper, {}),
            children: [
                {
                    path: 'owner',
                    element: _jsx(OwnerPage, {}),
                },
                {
                    path: 'currier',
                    element: _jsx(CurrierPage, {}),
                },
                {
                    path: ':flow/close-device',
                    element: _jsx(CloseDevice, {}),
                },
                {
                    path: ':flow/done',
                    element: _jsx(Done, {}),
                },
            ],
        },
    ]);
}
